import React from "react";

const Home = () => {
  return <div>Page d'accueil du dashboard</div>;
};

export default Home;
